import React from 'react';
import TaxBillColAndPayInfo from '../../components/taxIssuedmng/TaxBillColAndPayInfo';

const TaxBillColAndPayContainer = ({ taxbill }) => {
  return <TaxBillColAndPayInfo taxbill={taxbill} />
};

export default TaxBillColAndPayContainer;
